import React from 'react';
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { router } from "@/lib/router";
import { HelmetProvider } from 'react-helmet-async';
import CookieConsent from "@/components/CookieConsent";
import ErrorBoundary from '@/components/ErrorBoundary';
import RecaptchaProvider from '@/components/providers/RecaptchaProvider';
import './App.css';

// Initialize Google Analytics
const initializeGA = () => {
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=G-RW8M3BLL4T`;

  const script2 = document.createElement('script');
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'G-RW8M3BLL4T');
  `;

  document.head.appendChild(script1);
  document.head.appendChild(script2);
};

// Initialize GA when the app loads
if (typeof window !== 'undefined') {
  initializeGA();
}

const queryClient = new QueryClient();

const App = () => {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <RecaptchaProvider>
            <Toaster />
            <Sonner />
            <HelmetProvider>
              <RouterProvider router={router} />
            </HelmetProvider>
            <CookieConsent />
          </RecaptchaProvider>
        </TooltipProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
};

export default App;
